/* eslint-disable react/react-in-jsx-scope */
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike'
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun'
import PoolIcon from '@mui/icons-material/Pool'
import React from 'react'

import { TEAM_TYPES } from '../../../constants/models'
import FormCheckboxGroup, {
  Option,
} from '../elements/FormCheckboxGroup'

interface RelayEventInputProps {
  values: { teamType?: string; relayEvent?: string[] }
  currentRelayEvent: string[]
  selectedRelayEvent: string[]
  formDisabled?: boolean
  onRelayEventChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

/**
 * Shared relay event checkbox group.
 * Renders SWIM/BIKE/RUN or RUN1/BIKE/RUN2 based on teamType.
 */
const RelayEventInput = ({
  values,
  currentRelayEvent,
  selectedRelayEvent,
  formDisabled,
  onRelayEventChange,
}: RelayEventInputProps) => {
  const isDuathlon = values.teamType === TEAM_TYPES.DUATHLON
  const run2Value = `RUN${isDuathlon ? '2' : ''}`
  const run2Included = currentRelayEvent.includes(run2Value)
  const run2Selected = selectedRelayEvent.includes(run2Value)

  const options = [
    ...(isDuathlon
      ? [
          {
            text: 'RUN 1',
            value: 'RUN1',
            image: <DirectionsRunIcon />,
            disabled:
              !currentRelayEvent.includes('RUN1') &&
              selectedRelayEvent.includes('RUN1'),
          },
        ]
      : [
          {
            text: 'SWIM',
            value: 'SWIM',
            image: <PoolIcon />,
            disabled:
              !currentRelayEvent.includes('SWIM') &&
              selectedRelayEvent.includes('SWIM'),
          },
        ]),
    {
      text: 'BIKE',
      value: 'BIKE',
      image: <DirectionsBikeIcon />,
      disabled:
        !currentRelayEvent.includes('BIKE') &&
        selectedRelayEvent.includes('BIKE'),
    },
    {
      text: 'RUN 2',
      value: run2Value,
      image: <DirectionsRunIcon />,
      disabled: !run2Included && run2Selected,
    },
  ] as Option[]

  return (
    <FormCheckboxGroup
      name="relayEvent"
      label="Relay Event"
      required
      options={options}
      checkedOptions={values.relayEvent}
      disabled={formDisabled}
      placeholder="Select at least 1 Relay Event"
      onModified={onRelayEventChange}
    />
  )
}

export default RelayEventInput
